import * as memoMessageType from './resultOfConsiderType'
import useMemomessageTerminate from './useResultOfConsider'

import Grid from '@material-ui/core/Grid'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { memorandumTopic } from '../../../../../../constants/constants'
import useTranslate from '../../../../../../i18n/useTranslate'
import PageAction from '../../pageAction'
import Dialog from '../../../../../../control/dialog/dialog'
import MyAccordion from '../../../../../../control/accordion/accordion'
import TreeCheckbox from '../../../../../../control/treeCheckboxNew/treeCheckbox'
import MyTextfield from '../../../../../../control/textfield/textfield'
import RichTextEditor from '../../../../../../control/richTextEditor/richTextEditor'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../../constants/submittedStep'

//View
const MemoMessageView = (props: memoMessageType.MemomessageViewType) => {
    const {
        formRef,
        projectData,
        isViewMode,
        initialValues,
        configDialog,
        terminateCauseList,
        onRefDialog,
        isCheckedOther,
        onClickBackToSearch,
        initialCommentCommitee,
        initialMemorandumFile,
    } = props

    const translate = useTranslate()

    //มีการลงนามไปแล้ว
    const isSignMemoMessage: boolean =
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete

    // //มีการออกใบบันทึกข้อความไปแล้ว
    // const isMemoMessage: boolean = projectData?.stepID === constSubmittedStep.sign

    return (
        <Form
            onSubmit={() => {}}
            initialValues={{ ...initialValues, memorandumFile: initialMemorandumFile }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(formProps) => {
                formRef.current = formProps
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyAccordion title={translate.get('LABEL.NOTIFY_REVIEW_OUTCOME')}>
                                    <Grid item xs={12} md={12} lg={12}>
                                        {translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} : {translate.get('LABEL.APPROVE')}
                                    </Grid>
                                </MyAccordion>
                            </Grid>
                            {/* {isMemoMessage && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.TERMINATE_CAUSE')}>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <TreeCheckbox
                                                    disabled={isViewMode}
                                                    name={'terminateCause'}
                                                    dataSource={terminateCauseList}
                                                    labelRadioEN={translate.get('LABEL.ENG')}
                                                    labelRadioTH={translate.get('LABEL.THAI')}
                                                    isLangTH={
                                                        translate.languageStore.currentLanguage ===
                                                        translate.languageKey.th
                                                    }
                                                    onClickParentCheckbox={() => {}}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ marginLeft: '20px' }}>
                                                <MyTextfield
                                                    name="terminateCauseOther"
                                                    materialInputProps={{
                                                        disabled: isViewMode || !isCheckedOther,
                                                        placeholder: `${translate.get('LABEL.OTHER_CAUSE')} `,
                                                        size: 'small',
                                                    }}
                                                    maxLength={250}
                                                    required={isCheckedOther}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )} */}
                            <Grid item xs={12}>
                                <MyAccordion title={translate.get('LABEL.MEMO_MESSAGE_DETAIL')}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <RichTextEditor
                                                name={`commentCommittee`}
                                                initialRichTextEditor={initialCommentCommitee}
                                                disabled={isViewMode}
                                                isHideToolbar={isViewMode}
                                                label={translate.get('LABEL.SUGGESTION_NOTICE')}
                                            />
                                        </Grid>
                                    </Grid>
                                </MyAccordion>
                            </Grid>

                            {isSignMemoMessage && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        name={'memorandumFile'}
                                        initialData={initialMemorandumFile}
                                        documentTitleList={memorandumTopic}
                                        title={translate.get('LABEL.MEMO_MESSAGE_DOC')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                        // onClickOpenFile={onClickOpenFile}
                                    />
                                </Grid>
                            )}
                            {!isViewMode && (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickSaveDraft={() => {
                                            formProps.form.change('submitType', 'draft')
                                            formProps.handleSubmit()
                                        }}
                                        onClickSave={() => {
                                            formProps.form.change('submitType', 'save')
                                            formProps.handleSubmit()
                                        }}
                                        onClickClose={onClickBackToSearch}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {/* <FormSpy subscription={{ values: true, dirty: true }} onChange={onDirtyChange} /> */}
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}

//Controller
const MemomessageCtrl = (props: memoMessageType.MemomessageCtrlType) => {
    const useMemomessageTerminateModel = useMemomessageTerminate(props)
    return <MemoMessageView {...useMemomessageTerminateModel} {...props} />
}
export default MemomessageCtrl
